// @flow
import * as React from "react";

import MobileOfferTable from "./MobileOfferTable";
import CurrentOfferForm from "./CurrentOfferForm";
import OurPromises from "./OurPromises";
import { UserConsumer } from "../../../Commons/Modules/auth";

type Props = {
  match: {
    params: {
      id: ?string,
      category: ?string,
    },
  },
  userId: string,
};

class PhoneOffers extends React.Component<Props> {
  render() {
    return (
      <UserConsumer>
        {(userConsumerProps) =>
          userConsumerProps && (
            <div>
              <CurrentOfferForm
                reminderId={this.props.match.params.id}
                userId={userConsumerProps.userId}
                category="phone"
              />
              <MobileOfferTable reminderId={this.props.match.params.id} userId={userConsumerProps.userId} />
              <OurPromises />
            </div>
          )
        }
      </UserConsumer>
    );
  }
}

export default PhoneOffers;
